import { useEffect, useState } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import Tab1 from './Tab1';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import Data from '../../../Data/Data.json';
import { Crypter } from '../../../Functions/Security/Crypter';
import COMPTES from '../../../Models/Comptes';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import VerifDay from '../../../Functions/Traitement/VerifDay';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;
// TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

function handleClick(event: React.MouseEvent<Element, MouseEvent>) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}


const CompteGl = () => {
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("");
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [Load, SetLoad] = useState(false);
  const Navigate=useNavigate();


  useEffect(() => {
    forceUpdate({});
    if(Load===false)
    {
      VerifDay(user.coduti,user.codage,authHeader,Navigate);
      SetLoad(true);
     }
  }, []);

  function initialiazeButton() {
    SeStartSearchG(false)
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    SeStartSearchG(true)
    localStorage.setItem(Data.LocalVariable.reset, '0');
    setSbmit("add");
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields();
    form.setFieldValue("AGCCPT", user.codage);
    form.setFieldValue("lib_AGCCPT", user.agence);
    form.setFieldValue("CDDEVS", 'XAF');
    form.setFieldValue("lib_CDDEVS", 'FRANC CFA BEAC');
  }

  const SetEndStart = () => {

    SetStartForm(true);
    SeStartSearchG(false);
  }

  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI");
    form.resetFields();
    localStorage.clear();
    form.setFieldValue("CODUTI", coduti);
    initialiazeButton();
    localStorage.setItem(Data.LocalVariable.reset, "1");
    form.setFieldValue("AGCCPT", user.codage);
    form.setFieldValue("lib_AGCCPT", user.agence);
    form.setFieldValue("CDDEVS", 'XAF');
    form.setFieldValue("lib_CDDEVS", 'FRANC CFA BEAC');
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }

  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update");
    SeStartSearchG(true)
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Compte du Grand Livre
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} Function2={consulte} />,
    }
  ];


  const onFinish = (values: any) => {

    var Compte: COMPTES = values;
    // console.log(Compte.TSign1);
    Compte.UTILIS = user.coduti;
    Compte.TYPCPT='I'
    Compte.categocpt='I'

    let typcompte = form.getFieldValue("lib_IDPLAN");

    if (sbmit === "add") {
      Compte.DATCRE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
      SweetAlert.fire({
        title: "Creation De Compte",
        text: "Voulez-vous creer le Compte de " + Compte.NOMCPT + "  comme " + " " + typcompte + " ?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          //let group = profilsDistant.find(()=>)
          console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Compte)));

          let data = Crypter.encrypt(JSON.stringify(Compte));
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateNewCompte,
            headers: {
              // 'CypherCompte': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
               
                if (res.StatutCode === 200) {
                  if (res.Result.Table.length > 0) {
                    // initialiazeButton();
                    // localStorage.clear()
                    setIsSubmit(false);

                    // let data = res.Result.Table1.toString().replaceAll(',', " - ");
                    SweetAlert.fire({ title: res.Message, text: JSON.stringify(res.Result.Table1).replaceAll("{\"COMPTEGL\":\"", "COMPTE-Gl ------------:").replaceAll("[", '').replace("\"}]", '').replace("\"}]", '').replaceAll("},",":"), icon: "success" })
                    // localStorage.clear()
                    initialiazeButton();
                    form.resetFields();
                    setSbmit("")

                  }
                }
                else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });

        }
      })
    }
    if (sbmit === "update") {
      Compte.DATMAJ = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
      // alert(values)
      SweetAlert.fire({
        title: "Modification du Client",
        text: "Voulez-vous modifier compte " + Compte.NUMCPT + " ?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
          console.log('Received values of form: ', Compte);
          let data = Crypter.encrypt(JSON.stringify(Compte));
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateCompte,
            headers: {
              // 'CypherCompte': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };
          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode === 200) {
                  let code = Compte.NUMCPT;
                  form.resetFields();
                  // localStorage.clear();
                  setIsSubmit(false);
                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" });

                  initialiazeButton();
                  // localStorage.setItem(Data.LocalVariable.reset, '1');

                  setSbmit("");
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
        }
      })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    });

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
  };

  function consulte()
   {
    
    let data = Crypter.encrypt(form.getFieldValue("NUMCLI"));
    // let clearNumcli = form.getFieldValue("NUMCLI")
    if (data.length !== 0) {
      //initialiazeButton()
      setLoading(true)
      //form.resetFields()
      //form.setFieldValue("NUMCLI", clearNumcli)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetClient,
        headers: {
          'CypherNumcli': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },

      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode === 200) {
              let datas = res.Result.Table[0]

              if (res.Result.Table.length > 0) {

                // alert(JSON.stringify(datas));
                form.setFieldValue('cdgest', datas.CDGEST);
                form.setFieldValue('lib_cdgest', datas.lib_CDGEST);
                form.setFieldValue('NOMCPT', datas.NOMCLI);
                form.setFieldValue('CLECLI', datas.CLECLI);
                //form.setFieldValue('TelMobil', datas.telCli);

              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
              }
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }
  }

  function consult() {
    let data = Crypter.encrypt(form.getFieldValue("NUMCPT"));

    //let clearNumcli = form.getFieldValue("NUMCPT")
    // alert(data);
    //  localStorage.removeItem(Data.LocalVariable.AyantDCompte);
    //  localStorage.removeItem(Data.LocalVariable.Relationcompte);


    if (data.length !== 0) {
      initialiazeButton();
      setLoading(true);

      //form.resetFields()
      //form.setFieldValue("NUMCPT", clearNumcli)

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetCompte,
        headers: {
          'CypherNumCpte': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));
            if (res.StatutCode === 200) {

              let datas: COMPTES = res.Result.Table[0];
              localStorage.clear();

              if (res.Result.Table.length > 0) {
                // alert(JSON.stringify(datas));
                form.setFieldsValue(res.Result.Table[0]);
                form.setFieldValue('lib_NUMCPT', datas.NOMCPT);
                form.setFieldValue('DATCRE', datas.DATCRE ? (new Date(datas.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '')

                // initialiazeButton();
              } else {
                SweetAlert.fire({ title: "Warning", text: "Account not found", icon: "warning" })
              }
              // console.log(form.getFieldsValue())
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
          cunsultButton();
        })
        .catch((error) => {
          setLoading(false);
          // console.log(error)
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        });
    }
  }

  function modif() {
    modifButton()

  }

  return (
    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb
          label="Comptes DU GRAND LIVRE"
          deleteIcon={<ExpandMoreIcon />}
          onDelete={handleClick}
        />
      </Breadcrumbs></Box>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            </div>
          </div>
        </Form>
        <div>
          <div>

          </div>
        </div>
      </Spin>
    </div>

  );
}
export default CompteGl;